import React from "react";
import styles from "./MenuBar.module.css";
import etheriumIcon from "../../images/bitcoin.svg";
import addNewIcon from "../../images/addNewIcon.svg";
import { useSelector } from "react-redux";
import StripeCheckout from "react-stripe-checkout";
import { stripeKey } from "../../stripe";
import { useState } from "react";
import db from "../../firebase";
import { doc, updateDoc, increment } from "firebase/firestore";

const WalletSection = () => {
  const loggedUser = useSelector((state) => state.loggedUser);

  const [addAmountValue, setAddAmountValue] = useState(100);

  const onToken = (token) => {
    updateDoc(doc(db, "user_data", loggedUser.uid), {
      wallet: increment(addAmountValue),
    });
  };

  return (
    <div className={styles.walletSection}>
      <div className={styles.balanceSection}>
        <p className={styles.balanceSectionPara}>Total Balance</p>
        <h4 className={styles.balanceSectionHeading}>
          ${loggedUser && loggedUser.wallet} USD
        </h4>
        <div className={styles.balanceSectionAddFund}>
          <input
            type="text"
            placeholder="Amount"
            value={addAmountValue}
            maxLength="5"
            onChange={(e) =>
              e.target.value === ""
                ? setAddAmountValue(0)
                : setAddAmountValue(parseInt(e.target.value))
            }
          />
          <StripeCheckout
            name="Add To Wallet"
            token={onToken}
            stripeKey={stripeKey}
            amount={addAmountValue * 100}
            panelLabel="Add"
            email={loggedUser.email}
            currency="USD"
          >
            <button disabled={addAmountValue === 0 ? true : false}>Add</button>
          </StripeCheckout>
        </div>
      </div>
      {/* <div className={styles.transactionSection}>
        <div className={styles.transactionSingle}>
          <div className={styles.transactionBitIconOuter}>
            <img
              src={etheriumIcon}
              alt=""
              className={styles.transactionBitIcon}
            />
          </div>
          <div className={styles.transactionData}>
            <div className={styles.transactionDataBar}>
              <span>ETH</span>
              <span>0.0317</span>
            </div>
            <div
              className={`${styles.transactionDataBar} ${styles.transactionDataBarSecond}`}
            >
              <span>Ethereum</span>
              <span>$118.80</span>
            </div>
          </div>
          <div className={styles.transactionAddIconOuter}>
            <img
              src={addNewIcon}
              alt=""
              className={styles.transactionAddIcon}
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default WalletSection;
